"use client";

import { HeroSection } from "./_components/hero-section";
import { WhatsSpicenetSection } from "./_components/whats-spicenet-section";
import { StatsSection } from "./_components/stats-section";
import { LeaderboardSpotlightSection } from "./_components/leaderboard-spotlight-section";
import { FounderVideoSection } from "@/app/_components/founder-video-section";
import { BackedBySection } from "@/components/backed-by-section";
import { HomeLearnSection } from "@/app/_components/home-learn-section";

export default function HomePage() {
  return (
    <div className="w-full">
      <HeroSection />
      <WhatsSpicenetSection />
      <StatsSection />
      <LeaderboardSpotlightSection />
      <FounderVideoSection />
      <BackedBySection />
      <HomeLearnSection />
    </div>
  );
}
